import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bradwestfall/Desktop/ReactTraining/Projects/monorepo/reacttraining.com/src/page-templates/BlogArticlePage.js";
import TweetEmbed from '../../ui/blog/BlogTweetEmbed';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <div>
  <p className="text-large align-center">
    Besides the fact that you can't conditionalize your calls to <code>useState</code>,
    there's not really a strict set of rules to follow. However, there are some guidelines and some gotcha's to know about.
  </p>
    </div>
    <iframe width="100%" height="500" src="https://www.youtube.com/embed/aBv-Kq8AL94" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <hr />
    <h3 {...{
      "id": "3-part-series"
    }}><a parentName="h3" {...{
        "href": "#3-part-series",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`3-part Series`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/blog/state-and-the-declarative-approach"
        }}>{`How is state related to the declarative approach in React?`}</a>{` `}</li>
      <li parentName="ul">{`⭐️ How to use and not use state?`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#"
        }}>{`How do props relate to state?`}</a>{` `}{`[Coming Soon]`}</li>
    </ul>
    <hr />
    <p>{`When I'm teaching React's state to people who are seeing it for the first time, they usually have the same set's of questions:`}</p>
    <h2 {...{
      "id": "can-i-use-usestate-more-than-once"
    }}><a parentName="h2" {...{
        "href": "#can-i-use-usestate-more-than-once",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Can I use `}<code parentName="h2" {...{
        "className": "language-text"
      }}>{`useState`}</code>{` more than once?`}</h2>
    <p>{`Yes. In fact that's how it was designed to be used. You just can't conditionalize the calls to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{` because the call order matters to React. The number of times you called `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{` is tracked and React expects the same amount of calls each time. Otherwise they'll return the wrong information to you. From React's perspective, they don't know if you're conditionalizing a call to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{`, so the built-in linter will check to see if you are.`}</p>
    <p>{`For example you can't do this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`count`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` setCount`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`count `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`otherState`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` setOtherState`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`null`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`error`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` setError`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`null`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`If you could do the example above, then sometimes the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`error`}</code>{` call to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{` would be second and sometimes it would be third. That would be a problem for React.`}</p>
    <p>{`This always brings up another question...`}</p>
    <h2 {...{
      "id": "can-i-call-usestate-once-for-all-my-components-state"
    }}><a parentName="h2" {...{
        "href": "#can-i-call-usestate-once-for-all-my-components-state",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Can I call `}<code parentName="h2" {...{
        "className": "language-text"
      }}>{`useState`}</code>{` once for all my component's state?`}</h2>
    <p>{`Yes, but you might not want to.`}</p>
    <p>{`With class components we would keep all of our state in one object. Then when we changed state with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`setState`}</code>{`, we would provide an object and the API would "merge" its contents into the existing state for us. `}<u>{`This doesn't happen`}</u>{` with setting state in function components with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{`.`}</p>
    <p>{`If you did try to do it like this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`state`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` setState`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  count`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  error`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`null`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`add`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token function"
          }}>{`setState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` count`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` state`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`count `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`You'd end up destroying state you didn't mean to, like the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`error`}</code>{` in this case because calling `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`setState`}</code>{` will `}<u>{`replace`}</u>{` all existing state that you're storing in that particular call to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{`.`}</p>
    <p>{`If you choose to organize your state into a single object, you might have good reasons to. Just be sure to take care of preserving all the state when you make changes:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// The spread operator here takes all the existing state`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// and does a shallow copy into this new object:`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`setState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`...`}</span>{`state`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` count`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` state`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`count `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`If this doesn't make any sense, especially when I start talking about class components, that's okay. Maybe you don't need to know class components. I do go into more detail about how this works in the video above if you need more clarity.`}</p>
    <p><strong parentName="p">{`What about using useReducer instead?`}</strong></p>
    <p>{`The normal convention you'll hear is:`}</p>
    <blockquote>
      <p parentName="blockquote">{`If your state is complex, like a deeply nested object, `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`useReducer`}</code>{` is probably better than `}<code parentName="p" {...{
          "className": "language-text"
        }}>{`useState`}</code>{` for this type of state.`}</p>
    </blockquote>
    <p>{`That's the typical thing you'll hear in the React community. But we have more on that later in this document.`}</p>
    <h2 {...{
      "id": "is-that-the-only-reason-to-call-usestate-separately"
    }}><a parentName="h2" {...{
        "href": "#is-that-the-only-reason-to-call-usestate-separately",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Is that the only reason to call useState separately?`}</h2>
    <p>{`No. Even the `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/hooks-faq.html#should-i-use-one-or-many-state-variables"
      }}>{`official docs give you a hint`}</a>{` as to why they intended `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{` to be called separate times for each piece of state:`}</p>
    <blockquote>
      <p parentName="blockquote">{`"Separating independent state variables also has another benefit. It makes it easy to later extract some related logic into a custom Hook"`}</p>
    </blockquote>
    <p>{`In other words, if you wanted to abstract some of your re-usable code into a custom Hook, you might imagine that the hook has it's own state inside. What if this hook called `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useSomeCustomHook`}</code>{` was using two calls to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{`?`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`MyComponent`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`count`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` setCount`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` value `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useSomeCustomHook`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// might call useState twice inside it`}</span>{`

  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// ...`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`From React's perspective, they just when they call `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`MyComponent()`}</code>{` that they see three calls to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{`. One for `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`count`}</code>{` and two that are perceivably inside `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useSomeCustomHook()`}</code>{`.`}</p>
    <p>{`Custom hooks were one of the main driving reason hooks were created in the first place. The fact that using state with function components isn't restricted to one object and one instantiation of all state like with classes is what allows us to have components with local state such as `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`count`}</code>{` and them other local state from an custom Hooks.`}</p>
    <h2 {...{
      "id": "can-i-set-state-from-state"
    }}><a parentName="h2" {...{
        "href": "#can-i-set-state-from-state",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`Can I set state from state?`}</h2>
    <p>{`This type of question would only come from someone who had experience with class-based components. That's because it could be error-prone in classes to "set state from state" like this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// In classes, this could be error prone:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`this`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`setState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` count`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`this`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`state`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`count `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`For many reasons I won't get into here, you were supposed to do a different version of the state setting API when you wanted to set state from state in classes (to avoid bugs):`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`// The alternative API was to pass a function that`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// would receive the current state and return`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// new state:`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`this`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`setState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`currentState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` count`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` currentState`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`count `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`Without knowing too much about classes, just know the types of "state batching" problems that we were avoiding by doing this alternative API wouldn't be a problem in the first place with function-based components. So setting "state from state" is fine with function based components that use `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`count`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` setCount`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`add`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// setting state from state`}</span>{`
  `}<span parentName="code" {...{
            "className": "token function"
          }}>{`setCount`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`count `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`The state-setting function returned from `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{` can still be passed a function which resembles the class-based way of doing it, but the nuances of why you might need this go beyond the scope of this article and just know that you probably won't need to do this often:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`count`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` setCount`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`add`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token function"
          }}>{`setCount`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`currentCount`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` currentCount `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <h2 {...{
      "id": "when-do-i-use-a-reducer-instead-of-usestate"
    }}><a parentName="h2" {...{
        "href": "#when-do-i-use-a-reducer-instead-of-usestate",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`When do I use a reducer instead of `}<code parentName="h2" {...{
        "className": "language-text"
      }}>{`useState`}</code></h2>
    <p>{`Here's the quick facts on `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useReducer`}</code>{` vs `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{`:`}</p>
    <ul>
      <li parentName="ul">{`They both make local state`}</li>
      <li parentName="ul">{`You can use either one`}</li>
    </ul>
    <p>{`Some will argue that `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useReducer`}</code>{` has some intangible benefits over `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{` and I think they have some good points. I like using `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useReducer`}</code>{` for certain types of complex state. But just know that neither one has an aspect to its API that is impossible to solve with the other API. Here's what one of the owners of React Training had to say about it:`}</p>
    <TweetEmbed id="1387885971589386240" mdxType="TweetEmbed" />
    <p>{`In other words, Michael is not saying he `}<em parentName="p">{`always`}</em>{` uses an object to manage his state. He's just saying that when he has the type of state that most would consider a good use-case for `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useReducer`}</code>{`, he just uses an object with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`useState`}</code>{` instead -- the very thing that we just said to watch out for above.`}</p>
    <p>{`But that's okay, he knows what he's doing!`}</p>
    <p>{`We just want you to be aware that you have to manage the "merging" of your state on your own when it comes to function-components vs the older class ones.`}</p>
    <h2 {...{
      "id": "how-do-i-share-my-local-state-with-other-components"
    }}><a parentName="h2" {...{
        "href": "#how-do-i-share-my-local-state-with-other-components",
        "aria-hidden": "true",
        "tabIndex": -1
      }}><span parentName="a" {...{
          "className": "icon icon-link"
        }}></span></a>{`How do I "share" my local state with other components?`}</h2>
    <p>{`Oh boy, this is kind of a huge topic. The short answer is you need to `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/lifting-state-up.html"
      }}>{`lift state`}</a>{`.`}</p>
    <p>{`Let's say I had a little tree-structure where the main `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`App`}</code>{` was the owner component of the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<Count />`}</code>{` component we've been making and also a new `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<Report />`}</code>{` component which reports what the current count is:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "jsx"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`App`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Count`}</span></span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Report`}</span></span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
    `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`With the example above, the state for `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`count`}</code>{` is inside the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<Count />`}</code>{` component and is not being shared anywhere else.`}</p>
    <p>{`To `}<em parentName="p">{`lift`}</em>{` state, we would do this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "jsx"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`App`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// This state has been moved "lifted" up one level:`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`count`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` setCount`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`useState`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
      <Count count=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`count`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{` setCount =`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`setCount `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{` />
      `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`Report`}</span></span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`count`}</span><span parentName="span" {...{
              "className": "token script language-javascript"
            }}><span parentName="span" {...{
                "className": "token script-punctuation punctuation"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`count`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span><span parentName="code" {...{
            "className": "token plain-text"
          }}>{`
    `}</span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`div`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`The `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<Count />`}</code>{` component might look more like this now:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "jsx"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`Counter`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` count`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` setCount `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// const [count, setCount] = useState(0)`}</span>{`
  
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`add`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`setCount`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`count `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`+`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
  
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// ...`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`It doesn't have it's own state, it has props instead. The `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`add`}</code>{` function doesn't care where `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`count`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`setCount`}</code>{` come from. It just needs them to exist. When the button is clicked and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`add`}</code>{` calls `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`setCount`}</code>{` and the new series of steps that takes place to update the UI is as follows:`}</p>
    <ol>
      <li parentName="ol">{`Since `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`setCount`}</code>{` came from a `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`useState`}</code>{` in `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`App`}</code>{`, it's now the component that gets a re-render.`}</li>
      <li parentName="ol">{`On the re-render, we get the latest state from `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`useState`}</code>{` and then pass it down as props to other components.`}</li>
      <li parentName="ol">{`Components get re-rendered whenever they experience a state change or if their owner component gets re-rendered and therefore might be passing the child components new props.`}</li>
      <li parentName="ol">{`Therefore, both the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Report`}</code>{` and `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`Count`}</code>{` components get re-rendered to return new descriptions of their UI.`}</li>
    </ol>
    <p>{`These are all fundamental React concepts -- to lift state in order for two components to share it. From here though, it can turn into a much bigger conversation about how too much lifting state can lead to "prop drilling" and how prop drilling can be avoided with context and maybe you should be using Redux or MobX to handle global state and only use local state sometimes, etc, etc.`}</p>
    <p>{`But that's all for another time 😎`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      